import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/ubuntu/html/tablespace-website/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/home/ubuntu/html/tablespace-website/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderGrid"] */ "/home/ubuntu/html/tablespace-website/components/LeaderGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeadForm"] */ "/home/ubuntu/html/tablespace-website/components/LeadForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/components/Motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MilestonesCarousel"] */ "/home/ubuntu/html/tablespace-website/components/sections/MilestonesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValuesAccordion"] */ "/home/ubuntu/html/tablespace-website/components/sections/ValuesAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/html/tablespace-website/node_modules/next/dist/client/app-dir/link.js");
